import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchMyBadges } from '../api/badges';

// Async atom — fetches the current user's badges on first read.
const myBadgesFetchAtom = atom(async () => {
    const data = await fetchMyBadges();
    return data;
});

const myBadgesLoadableAtom = loadable(myBadgesFetchAtom);

const EMPTY_BADGES = { earned: [], locked: { bronze: 0, silver: 0, gold: 0, diamond: 0 } };

// Self-loading, read-only. Returns the empty shape while loading.
// Shape: { earned: DisplayBadge[], locked: { bronze, silver, gold, diamond } }
export const userBadgesAtom = atom((get) => {
    const fetched = get(myBadgesLoadableAtom);
    return fetched.state === 'hasData' ? fetched.data : EMPTY_BADGES;
});
